import { z } from 'zod';
/** An empty name is how a pipeline says a slot is deliberately unused, rather than missing. */
export const FEED_UNUSED_TARGET_FIELD = '';
/**
 * One pipeline: the columns it reads, the columns it writes, and the ordered steps between. A
 * step's `options` are whatever the named feed function takes, so they are not described here.
 */
export const FeedCellPipelineContentSchema = z
    .object({
    sourceFields: z.array(z.string()).nullable(),
    targetFields: z.array(z.string()).nullable(),
    steps: z.array(z
        .object({
        functionName: z.string().min(1),
        options: z.looseObject({}),
    })
        .strict()),
    runIndex: z.number(),
})
    .strict();
/** The whole set is sent at once: a pipeline missing from the body is a pipeline removed. */
export const FeedCellPipelineBulkUpdateSchema = z.array(FeedCellPipelineContentSchema);
//# sourceMappingURL=cellPipeline.js.map